import React from "react";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  Stack,
  Typography,
  FormControl,
  FormLabel,
  Textarea,
  Button,
} from "@mui/joy";
import { AccessRequest } from "../../common/types";

interface RejectAccessRequestModalProps {
  open: boolean;
  onClose: () => void;
  request: AccessRequest | null;
  rejectReason: string;
  onRejectReasonChange: (reason: string) => void;
  onReject: () => void;
  rejecting: boolean;
}

const RejectAccessRequestModal: React.FC<RejectAccessRequestModalProps> = ({
  open,
  onClose,
  request,
  rejectReason,
  onRejectReasonChange,
  onReject,
  rejecting,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        size="md"
        variant="outlined"
        sx={{
          maxWidth: 500,
          width: "100%",
        }}
      >
        <DialogTitle>Reject Access Request</DialogTitle>

        <Stack spacing={3}>
          <Typography level="body-md">
            Are you sure you want to reject the access request from{" "}
            <strong>{request?.email}</strong>?
          </Typography>

          <FormControl>
            <FormLabel>Reason (Optional)</FormLabel>
            <Textarea
              placeholder="Not authorized for this organization..."
              value={rejectReason}
              onChange={(e) => onRejectReasonChange(e.target.value)}
              disabled={rejecting}
              size="md"
              minRows={2}
            />
          </FormControl>

          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "flex-end", mt: 2 }}
          >
            <Button
              variant="outlined"
              color="neutral"
              onClick={onClose}
              disabled={rejecting}
              size="md"
            >
              Cancel
            </Button>
            <Button
              variant="solid"
              color="danger"
              onClick={onReject}
              disabled={rejecting}
              loading={rejecting}
              size="md"
            >
              Reject Request
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default RejectAccessRequestModal;
